// app/javascript/controllers/autocomplete_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "hidden", "results"]
  timeout = null

  debouncedSearch() {
    clearTimeout(this.timeout)

    const query = this.inputTarget.value.trim()
    if (query.length < 3) {
      this.clearSuggestions()
      return
    }

    this.timeout = setTimeout(() => {
      this.search(query)
    }, 300)
  }

  search(query) {
    fetch(`/tenants/autocomplete?q=${encodeURIComponent(query)}`, {
      headers: {
        Accept: "text/vnd.turbo-stream.html"
      }
    })
      .then(response => response.text())
      .then(html => {
        this.resultsTarget.innerHTML = html
      })
  }

  select(event) {
    const name = event.target.dataset.tenantName
    const id = event.target.dataset.tenantId
    this.inputTarget.value = name
    this.hiddenTarget.value = id
    this.clearSuggestions()
  }

  clearSuggestions() {
    this.resultsTarget.innerHTML = ""
  }
}